import { Bell, Check, Info, AlertTriangle, MessageSquare } from 'lucide-react';
import { ThemeToggle } from '@/components/theme-toggle';

export function UserNotifications() {
  const notifications = [
    { id: 1, type: 'info', title: 'System Maintenance', message: 'Scheduled maintenance this Saturday from 2 AM to 4 AM UTC.', date: '2 hours ago', read: false },
    { id: 2, type: 'success', title: 'Ticket Resolved', message: 'Your ticket "Need access to Figma" has been resolved.', date: '1 day ago', read: false },
    { id: 3, type: 'alert', title: 'Password Expiry', message: 'Your password will expire in 3 days. Please change it.', date: '2 days ago', read: true },
    { id: 4, type: 'message', title: 'New Comment', message: 'IT Support added a comment to your ticket.', date: '3 days ago', read: true }
  ];

  const getIcon = (type: string) => {
    switch (type) {
      case 'info': return <Info className="h-4 w-4 text-blue-500" />;
      case 'success': return <Check className="h-4 w-4 text-emerald-500" />;
      case 'alert': return <AlertTriangle className="h-4 w-4 text-orange-500" />;
      case 'message': return <MessageSquare className="h-4 w-4 text-primary" />;
      default: return <Bell className="h-4 w-4 text-muted-foreground" />;
    }
  };

  return (
    <div className="flex h-full flex-col bg-theme p-6 overflow-y-auto">
      <div className="mx-auto max-w-4xl w-full">
        
        <div className="flex justify-between items-center mb-6">
          <div>
            <h1 className="font-display text-2xl font-semibold tracking-tight">Notifications</h1>
            <p className="text-muted-foreground mt-1">Stay updated with system alerts and ticket updates.</p>
          </div>
          <ThemeToggle />
        </div>

        <div className="neo rounded-2xl overflow-hidden">
          <div className="p-4 border-b border-border flex justify-between items-center bg-muted/30">
            <h2 className="font-medium text-sm">Recent Notifications</h2>
            <button className="text-xs text-primary font-medium hover:underline">Mark all as read</button>
          </div>
          <div className="divide-y divide-border">
            {notifications.map((notif) => (
              <div key={notif.id} className={`p-4 flex gap-4 transition hover:bg-muted/50 ${!notif.read ? 'bg-primary/5' : ''}`}>
                <div className="mt-0.5">
                  <div className="h-8 w-8 rounded-full neo-inset border-none bg-transparent flex items-center justify-center">
                    {getIcon(notif.type)}
                  </div>
                </div>
                <div className="flex-1">
                  <div className="flex justify-between items-start mb-1">
                    <h3 className={`text-sm ${!notif.read ? 'font-semibold text-foreground' : 'font-medium text-foreground'}`}>
                      {notif.title}
                    </h3>
                    <span className="text-xs text-muted-foreground whitespace-nowrap ml-4">{notif.date}</span>
                  </div>
                  <p className="text-sm text-muted-foreground">{notif.message}</p>
                </div>
                {!notif.read && (
                  <div className="flex items-center justify-center">
                    <div className="w-2 h-2 rounded-full bg-primary" title="Unread"></div>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
